var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1800 640.8c-1152 0-1710 1159.2-1710 1159.2s554.4 1159.2 1710 1159.2 1710-1159.2 1710-1159.2-558-1159.2-1710-1159.2zm0 2055.6c-496.8 0-896.4-403.2-896.4-896.4 0-496.8 403.2-896.4 896.4-896.4s896.4 403.2 896.4 896.4c0 496.8-399.6 896.4-896.4 896.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2379.6 1800c0 207.07-110.47 398.41-289.8 501.95-179.33 103.54-400.27 103.54-579.6 0-179.33-103.54-289.8-294.88-289.8-501.95s110.47-398.41 289.8-501.95c179.33-103.54 400.27-103.54 579.6 0 179.33 103.54 289.8 294.88 289.8 501.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon1);
export default __webpack_public_path__ + "static/media/viewIcon1.a48e951289c55f3f88539e490cbecac1.svg";
export { ForwardRef as ReactComponent };